module.exports = __webpack_public_path__ + "img/Hubspot.aef4cda9.png";